import { useEffect, useState } from 'react';
import axios from 'axios';
import { Mail, UserRoundCog } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../App';
import { jobErrorMessage } from '../lib/jobReference';

export const JobAdminActions = ({ job, onUpdated, onEmail }) => {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(job.assigned_to_user_id);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const loadUsers = async () => {
    setLoading(true);
    setError('');
    try { const { data } = await axios.get(`${API}/admin/users`); setUsers(data); }
    catch { setError('Unable to load staff. Please retry.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { loadUsers(); }, []);
  useEffect(() => { setSelected(job.assigned_to_user_id); }, [job.assigned_to_user_id]);
  const save = async () => {
    setSaving(true); setError('');
    try {
      const { data } = await axios.post(`${API}/appointments/${job.id}/reassign`, { assigned_to_user_id: selected });
      toast.success('Job reassigned'); onUpdated(data);
    } catch (err) { setError(jobErrorMessage(err, 'Unable to reassign this job.')); }
    finally { setSaving(false); }
  };
  return <section className="job-admin-actions" data-testid="job-admin-actions">
    <div className="job-reassignment">
      <label htmlFor="job-reassign-select" className="flex items-center gap-2"><UserRoundCog size={18} />Reassign</label>
      <select id="job-reassign-select" data-testid="job-reassign-select" className="retro-input" value={selected} onChange={e => setSelected(e.target.value)} disabled={loading || saving}>
        {loading && <option value={selected}>Loading staff…</option>}
        {!loading && !users.some(u => u.id === selected) && <option value={selected}>Select staff member</option>}
        {users.map(u => <option value={u.id} key={u.id}>{u.username}</option>)}
      </select>
      <button type="button" data-testid="job-reassign-save" className="retro-btn" onClick={save} disabled={loading || saving || !selected || selected === job.assigned_to_user_id}>{saving ? 'Saving…' : 'Save assignment'}</button>
    </div>
    <button type="button" className="retro-btn inline-flex items-center gap-2" data-testid="job-email-customer" onClick={onEmail} disabled={saving}><Mail size={18} />Email customer</button>
    {error && <div role="alert" data-testid="job-reassign-error" className="job-action-error">{error}{!users.length && <button type="button" data-testid="job-reassign-retry" onClick={loadUsers}>Retry</button>}</div>}
  </section>;
};